import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import type { X4Machine } from "@packsize/schemas/machines";

import { getX4Machines } from "@/api/machines/x4-api-v2";

import { type UseMachinesQueryOptions } from "../types";

import { X4_MACHINES_QUERY_KEY } from "./query-keys";

const REFETCH_INTERVAL = 15 * 1000;

export const getX4MachinesQuery = <TData = X4Machine[], TError = Error>(
	options?: UseMachinesQueryOptions<TData, TError>,
) => ({
	queryKey: X4_MACHINES_QUERY_KEY,
	queryFn: getX4Machines,
	refetchInterval: REFETCH_INTERVAL,
	staleTime: 10 * 1000,
	...options,
});

export const useX4Machines = (
	options?: UseMachinesQueryOptions<X4Machine[], Error>,
): UseQueryResult<X4Machine[], Error> => {
	return useQuery<X4Machine[], Error>(getX4MachinesQuery(options));
};
